<template>
    <b-row
        id="story"
        align-v="center"
        align-h="center"
        class="align-items-lg-start"
    >
        <b-col
            cols="5"
            md="3"
            lg="3"
            class="author text-center"
        >
            <story-author :author="story.author" />
        </b-col>

        <b-col 
            cols="7"
            md="4"
            class="d-lg-none"
        >
            <h4> {{ $t(story.title) }} </h4>
        </b-col>

        <b-col
            md="9"
            lg="6"
            class="no-gutters mt-1 mt-md-0"
        >
            <h4 class="col-lg-8 col-xl-5 d-none d-lg-block mt-3 mb-4">
                {{ $t(story.title) }}
            </h4>

            <p class="text-danger text-center text-lg-left mb-3 mb-xl-4">
                <fa icon="quote-right" />
            </p>

            <p> {{ $t(story.text) }} </p>
        </b-col>
    </b-row>
</template>

<script>
import StoryAuthor from '@/components/common/StoryAuthor';

export default {
    name: 'Story',
    components: { StoryAuthor },
    props: {
        story: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
#story {
    @include media-breakpoint-up(xl) {
        min-height: 30rem;
    }

    @include media-breakpoint-down(xs) {
        .author {
            margin-left: -10%;

            ::v-deep .author-info {
                right: 23%;
                font-size: .7rem;
            }
        }
    }
}
</style>
